import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { Subject } from 'rxjs';

import { TakeUntilDestroy } from '../../../common/take-until-destroy.decorator';
import { StateToProps } from '../../../store';
import { useDispatcher, UseStore } from '../../../store.decorator';

import { TranslationKeyMap } from './fl-winning.i18n';
import { determineStrDate2 } from './function/determine-str-date-2';
import { mainReducer } from './main/main.reducer';
import { MainState } from './main/main.state';
import { reload } from './main/state/reload.action';
import { PersonOfInterest } from './model/fl-winning.global.model';
import { FLWinningPerson } from './model/fl-winning.model';
import { FLWinningService } from './services/fl-winning.service';

@Component({
    selector: 'cmps-fl-winning-grid-main',
    templateUrl: './fl-winning-grid.component.html',
    host: {
        class: 'cmps-mi2-main',
    },
})
@TakeUntilDestroy()
@UseStore<MainState>('frontline.winning.main', mainReducer)
export class FlWinningGridComponent
    implements OnDestroy, OnInit, StateToProps<MainState>
{
    @Input() selectedUser: number;
    flWinningPersonData: FLWinningPerson;
    selectedFavouriteView: PersonOfInterest;
    @Output() flWinningPersonChange: EventEmitter<FLWinningPerson>;
    cameFromFlWinning: boolean;
    flPersonchange: Subject<FLWinningPerson> = new Subject<FLWinningPerson>();

    /** @private */
    _i18n = TranslationKeyMap;
    tlUserId: number;
    isGridFilled: boolean;

    constructor(private readonly _flwinningService: FLWinningService) {
        this.flWinningPersonChange = new EventEmitter();
        this.cameFromFlWinning = false;
    }

    ngOnInit(): void {
        useDispatcher(this, reload({ userId: this.selectedUser }));
        setTimeout(() => {
            this._flwinningService.setDataRangeID(
                this.state.selectedDataRangeId,
            );
            this._flwinningService.setEvalRangeID(
                this.state.selectedEvalRangeId,
            );
            this.retrieveFLWinning(
                this.selectedUser,
                this.state.selectedDataRangeId,
                this.state.selectedEvalRangeId,
            );
        }, 500);
    }

    state: MainState;

    ngOnDestroy(): void {
        this.flWinningPersonChange.complete();
    }

    handleCurrentViewChange(e: any): void {
        this.cameFromFlWinning = true;
        this.isGridFilled = false;
        this.selectedFavouriteView = e;
        const currentFLWinning = this._flwinningService._flwp.getValue();
        const FLWPUser = currentFLWinning.subOrdinates.find(
            (sub) => sub.userId === e.userId,
        );
        this.tlUserId = e.userId;
        FLWPUser.firstName = FLWPUser.fullName;
        this.flWinningPersonChange.emit(FLWPUser);
    }

    retrieveFLWinning(
        userId: number,
        dataRangeId?: number,
        evaluationRangeId?: number,
    ): void {
        const a = this._flwinningService.retrieveFLWinning(
            userId,
            dataRangeId,
            evaluationRangeId,
        );
        this.isGridFilled = false;
        const data = a.subscribe((res) => {
            data.unsubscribe();
            res.userDates = res.userDates?.map((userDate) => ({
                ...userDate,
                createdOn: determineStrDate2(userDate.createdOn),
            }));
            this.isGridFilled = true;
            res.isTop = true;
            this.flWinningPersonData = res;
            setTimeout(() => {
                this.flPersonchange.next({ ...res });
            }, 200);
        });
    }

    goBackToStoredFavourite(): void {
        this.flWinningPersonChange.emit(undefined);
        this.cameFromFlWinning = false;
        this._flwinningService.setDataRangeID(this.state.selectedDataRangeId);
        this._flwinningService.setEvalRangeID(this.state.selectedEvalRangeId);
        this.retrieveFLWinning(
            this.selectedUser,
            this.state.selectedDataRangeId,
            this.state.selectedEvalRangeId,
        );
    }

    /** @private */
    _onDataRangeChange(dataRangeIdEvt: Event): void {
        const dataRangeNum = parseInt(
            (dataRangeIdEvt.target as HTMLOptionElement).value,
        );
        this._flwinningService.setDataRangeID(dataRangeNum);
        this._flwinningService.setEvalRangeID(this.state.selectedEvalRangeId);
        this.retrieveFLWinning(
            this.selectedUser,
            dataRangeNum,
            this.state.selectedEvalRangeId,
        );
        useDispatcher(
            this,
            reload({
                userId: this.selectedUser,
                dataRangeId: dataRangeNum,
                evalRangeId: this.state.selectedEvalRangeId,
            }),
        );
    }

    _onEvalRangeChange(evalRangeIdEvt: Event): void {
        const evalRangeIdNum = parseInt(
            (evalRangeIdEvt.target as HTMLOptionElement).value,
        );
        this._flwinningService.setEvalRangeID(evalRangeIdNum);
        this._flwinningService.setDataRangeID(this.state.selectedDataRangeId);
        this.retrieveFLWinning(
            this.selectedUser,
            this.state.selectedDataRangeId,
            evalRangeIdNum,
        );
        useDispatcher(
            this,
            reload({
                userId: this.selectedUser,
                dataRangeId: this.state.selectedDataRangeId,
                evalRangeId: evalRangeIdNum,
            }),
        );
    }
}
